import React from "react";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>
        Google Chrome / Safari / Microsoft
        EdgeでPDF表示用の拡張機能を使用している場合、PDFを正常に開けないことがあります。（例：Adobe
        Acrobat Readerなど）
      </p>
    </div>
    <div>
      <p className={styles.heading}>▶ 対処方法</p>
      <p className={styles.text}>
        使用しているブラウザの設定からPDF関連の拡張機能を一時的に無効化して再度ダウンロードをお試しください。
      </p>
    </div>
  </div>
);

export const PDF_DOWNLOAD_ERROR_FAQ: FaqCategoryItem = {
  id: "pdf-download-error-faq",
  question: "PDFのダウンロードでエラーが出る",
  Answer,
};
